<div class="wrapper">

  <section id="banner-home" class="banner-container hero is-fullheight banner-landing-permanente"
    style="background-image:url(assets/img/bg-landing-permanente.jpg)">
    <div class="hero-body">
      <div class="container">
        <div class="columns">
          <div class="column is-6">
            <h1>Viaje com a Montreal e Economize até 60% em Diárias</h1>
            <h5>SEU DESTINO É VIAJAR GASTANDO POUCO E APROVEITANDO O MUNDO!</h5>
            <p class="descricao-indique">
              • Taxa de Adesão ZERO
              <br>
              • Os Melhores Resorts, Hotéis e Pousadas
              <br>
              • 24 meses para usar suas Diárias Aonde Quiser
              <br>
              • Marque sua Hospedagem sem sair de casa
            </p>

          </div>
          <div class="column is-6 area-indique" id="target_area_indique">
            <div class="area-form">
              <form class="sample-form" method="post" action-xhr="/documentation/examples/api/phone" target="_top">
                <h4 *ngIf="!formEnviado" id="indicar-amigos">Quer Saber como o Clube Funciona?</h4>

                <p *ngIf="!formEnviado">Preencha os Campos Abaixo que nós Te Ligamos!</p>

                <div class="area-inputs" *ngIf="!formEnviado">
                  <div class="field indique-amigos" tabindex="1">
                    <input name="nome" type="text" [(ngModel)]="nome" placeholder="Digite seu nome" required>
                  </div>

                  <div class="field indique-amigos" tabindex="1">
                    <input name="email" type="email" [(ngModel)]="email" placeholder="E-mail" required>
                  </div>

                  <div class="field indique-amigos" tabindex="1">
                    <input name="celular" type="tel" mask="00000000000" [(ngModel)]="telefone" placeholder="Celular"
                      mask-output="alphanumeric" required>
                  </div>

                  <button class="btn-verde" type="button">SABER MAIS</button>

                  <span class="voce-seguro">Você está Seguro com a gente. Seus dados pessoais serão utilizados somente
                    para a comunicação entre a Montreal e Você. Não compartilhamos suas informações com
                    terceiros.</span>
                </div>

                <div class="area-sucesso" *ngIf="formEnviado">
                  <h2>
                    <img class="icon-montreal" src="assets/img/icon-sucesso-cadastro.png" />
                    OBRIGADO
                  </h2>

                  <p><strong>Em breve, um de nossos especialistas entrará em contato com você e seu amigo
                      indicado.</strong></p>

                  <p>Enquanto isso, que tal continuar navegando em nosso site, conhecer nossos hotéis e já começar a
                    planejar sua próxima viagem?</p>

                  <a href="/hoteis" class="btn-verde">DESCOBRIR HOTÉIS E DESTINOS</a>
                  <a (click)="indicarMais()" class="link-verde">Indicar mais amigos</a>
                </div>

              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section id="melhor-clube-hospedagem-2">
    <div class="container">
      <div class="columns">
        <div class="column is-6">
          <h3>O melhor Clube de <br>Hospedagem do Brasil</h3>
          <p>A Montreal é o Clube de Hospedagem onde você paga um Pouquinho por Mês e pode se Hospedar nos Melhores
            Resorts, Hotéis e Pousadas do Brasil. Confira nossas Vantagens!</p>
        </div>
      </div>

      <div class="columns">
        <div class="column is-4 text-center">
          <div class="area-icon">
            <i class="fas fa-hand-holding-usd"></i>
          </div>
          <p><strong>TAXA DE ADESÃO ZERO</strong><br>Faça parte do Melhor Clube de Hospedagem sem se preocupar com Taxa
            de Adesão. Ela fica Por Nossa Conta!</p>
        </div>
        <div class="column is-4 text-center">
          <div class="area-icon">
            <i class="far fa-calendar-alt"></i>
          </div>
          <p><strong>24 MESES PARA VIAJAR *</strong><br>Aproveite para Planejar suas Viagens com Tranquilidade e
            Conforto. Você tem até 24 meses para utilizar suas diárias.</p>
        </div>
        <div class="column is-4 text-center">
          <div class="area-icon">
            <i class="fas fa-building"></i>
          </div>
          <p><strong>QUALIDADE EM HOSPEDAGEM</strong><br>Nossos Parceiros atendem a Todos os Gostos: Os Melhores
            Destinos para a Família, para quem quer Relaxar, para os Aventureiros, para quem não abre mão de Luxo...</p>
        </div>
      </div>

      <div class="columns">
        <div class="column is-4 text-center">
          <div class="area-icon">
            <i class="fas fa-user-plus"></i>
          </div>
          <p><strong>INDIQUE AMIGOS E GANHE DINHEIRO</strong><br>A cada amigo indicado que entrar para o Clube, você
            Ganha o valor de Uma Mensalidade do Plano que ele contratou em Sua Conta Bancária!</p>
        </div>

        <div class="column is-4 text-center">
          <div class="area-icon">
            <i class="fas fa-mobile-alt"></i>
          </div>
          <p><strong>MARQUE SUA VIAGEM PELO CELULAR</strong><br>Somos o Primeiro Clube de Hospedagem com Aplicativo
            Mobile para facilitar sua viagem. Pesquise por Destinos e Hospedagens, Compare Preços, Marque sua Viagem e
            Muito Mais!</p>
        </div>

        <div class="column is-4 text-center">
          <div class="area-icon">
            <i class="fas fa-plane"></i>
          </div>
          <p><strong>CLUBE DE VANTAGENS MONTREAL+</strong><br>Para nós, toda Economia é Pouca! No nosso Clube de
            Vantagens Exclusivo para Clientes você ganha descontos em Aluguel de Carro, Cinema, Eletrônicos, Roupas,
            Serviços...</p>
        </div>
        <br><br>
      </div>
      <p><small>* Para fazer jus ao benefício de extensão do prazo de utilização do Plano de Hospedagem, <br>observe
          previamente as condições previstas no art. 30 do Regulamento Montreal.</small></p>
    </div>
  </section>

  <section id="destinos" class="destinos-landing">

    <div class="container is-fluid">
      <div class="columns">
        <div class="column is-10">
          <h3 class="title">Destinos Incríveis</h3>
          <p><strong>Lugares Famosos ou Desertos? Novidade ou quer se Sentir em Casa? Você Escolhe!</strong></p>
          <p>Nosso conceito é simples: Você paga pequenas parcelas fixas todo mês e adquire diárias para se hospedar em
            qualquer hotel contratado pela Montreal Clube de hospedagem. Para fazer parte, escolha o plano que mais
            combina com você, a quantidade de diárias e quantas pessoas vão viajar. Depois é só escolher seu destino,
            marcar sua viagem e aproveitar!</p>
        </div>
      </div>

      <div class="itens-destinos">
        <div class="tile is-ancestor">
          <div class="tile is-vertical is-3">
            <div class="tile">
              <div class="tile is-parent is-vertical">
                <article class="tile is-child notification is-primary"
                  style="background-size: cover; background-image: url(&quot;https://www.clubemontreal.com.br/design/Destinos_Site_Novo/Caldas_Novas/caldas_desktop01.jpg&quot;);">
                  <div class="img-overlay"></div>
                  <div class="footer">
                    <p class="title">Caldas Novas </p>
                    <p class="subtitle"><i class="fas fa-map-marker"></i> Goiás</p>
                    Caldas Novas é um destino que reúne conforto, lazer e experiências de aventura ideais — tanto...
                  </div>
                </article>
                <article class="tile is-child notification is-primary"
                  style="background-size: cover; background-image: url(&quot;https://www.clubemontreal.com.br/design/Destinos_Site_Novo/Joao_Pessoa/joaopessoa_desktop01.jpg&quot;);">
                  <div class="img-overlay"></div>
                  <div class="footer">
                    <p class="title">João Pessoa </p>
                    <p class="subtitle"><i class="fas fa-map-marker"></i> Paraiba</p>
                    O nordeste brasileiro é uma das primeiras escolhas de destino de quem quer aproveitar as férias à
                    beira-mar.
                  </div>
                </article>
              </div>
            </div>
          </div>
          <div class="tile is-vertical is-3">
            <div class="tile">
              <div class="tile is-parent is-vertical">
                <article class="tile is-child notification is-primary"
                  style="background-size: cover; background-image: url(&quot;https://www.clubemontreal.com.br/design/Destinos_Site_Novo/Fortaleza/fortaleza_desktop01.jpg&quot;);">
                  <div class="img-overlay"></div>
                  <div class="footer">
                    <p class="title">Fortaleza </p>
                    <p class="subtitle"><i class="fas fa-map-marker"></i> Ceará</p>
                    Fortaleza é um dos principais destinos de turistas que desejam conhecer o nordeste brasileiro...
                  </div>
                </article>
                <article class="tile is-child notification is-primary"
                  style="background-size: cover; background-image: url(&quot;https://www.clubemontreal.com.br/design/Destinos_Site_Novo/Florianopolis/floripa_desktop01.jpg&quot;);">
                  <div class="img-overlay"></div>
                  <div class="footer">
                    <p class="title">Florianópolis </p>
                    <p class="subtitle"><i class="fas fa-map-marker"></i> Santa Catarina</p>
                    Conhecida como “Ilha da Magia”, a capital catarinense é um destinos mais queridos por
                    estrangeiros...
                  </div>
                </article>
              </div>
            </div>
          </div>
          <div class="tile is-vertical is-6">
            <div class="tile">
              <div class="tile is-parent is-vertical">
                <article class="tile is-child notification is-primary"
                  style="background-size: cover; background-image: url(&quot;https://www.clubemontreal.com.br/design/Destinos_Site_Novo/Brasilia/brasilia_desktop01.jpg&quot;);">
                  <div class="img-overlay"></div>
                  <div class="footer">
                    <p class="title">Brasília </p>
                    <p class="subtitle"><i class="fas fa-map-marker"></i> Distrito Federal</p>
                    O projeto urbanístico de Lúcio Costa e a arquitetura de Oscar Niemeyer são um convite à
                    fotografia...
                  </div>
                </article>
                <article class="tile is-child notification is-primary"
                  style="background-size: cover; background-image: url(&quot;https://www.clubemontreal.com.br/design/Destinos_Site_Novo/Pirenopolis/pirenopolis_desktop01.jpg&quot;);">
                  <div class="img-overlay"></div>
                  <div class="footer">
                    <p class="title">Pirenópolis </p>
                    <p class="subtitle"><i class="fas fa-map-marker"></i> Goiás</p>
                    Pousadas e restaurantes sofisticados fazem da cidade goiana um polo do turismo de aventura,
                    cultura...
                  </div>
                </article>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </section>



  <section id="montreal-depoimentos">
    <div class="container">
      <h3 class="title">O que nossos clientes falam?</h3>
      <div class="columns">
        <div class="column is-4">
          <div class="depoimento">
            <p><i>"Sempre viajamos para Petrópolis e em especial nessa data: era aniversário de 1 ano e 11 meses de
                casados. Queríamos aproveitar o clima friozinho, as boas comidas e ir passear pela cidade que amamos de
                paixão. Viagem maravilhosa para o destino que mais amamos. Ficamos no Atelier Molinaro Boutique Hotel,
                superrecomendo. Hotel em meio à natureza com atendimento maravilhoso."</i></p>
            <p>
              <strong>Daiane Ferreira e Tiago Custodio</strong>
            </p>
            <p class="remetente-destinatario"><small>De onde: Uberaba – MG</small> <br><small>Para onde: Atelier
                Molinaro Boutique Hotel - Petrópolis – RJ</small></p>
          </div>
        </div>
        <div class="column is-4">
          <div class="depoimento">
            <p><i> "A viagem foi maravilhosa e foi a nossa primeira vez no hotel Tauá Caeté, onde comemoramos nosso 26º
                aniversário de casamento. O hotel, de atendimento e estrutura gigantescos, nos deixou muito satisfeitos,
                com localização agradável, em comunhão com a natureza, perfeito para a época de frio, mas com área de
                lazer apropriada para todo o ano."</i></p>
            <p>
              <strong>Ronildo e Eliana</strong>
            </p>
            <p class="remetente-destinatario"><small>De onde: João Monlevade – MG</small> <br><small>Para onde: Tauá
                Resort Caeté Caeté – MG</small></p>
          </div>
        </div>
        <div class="column is-4">
          <div class="depoimento">
            <p><i> "Ficamos na Pousada Vila Colonial, lugar muito aconchegante. Fomos recebidos com muito carinho, e o
                melhor é que eles aceitam animais de estimação. Pirenópolis, uma cidade linda, com muita cultura, lugar
                certo para descansar. Passamos o fi nal de semana do Dia das Mães. Excelentes restaurantes e ótimo
                atendimento. Lugar de pessoas hospitaleiras e felizes. Adorei a cidade."</i></p>
            <p>
              <strong>Kattia, Vicente, Gabriela e Eduardo</strong>
            </p>
            <p class="remetente-destinatario"><small>De onde: Rio Verde – GO</small> <br><small>Para onde: Pousada Vila
                Colonial Pirenópolis – GO</small></p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section id="como-funciona-clube-montreal">
    <div class="container">
      <div class="columns">
        <div class="column is-6">
          <h3>Entenda como funciona o Clube Montreal</h3>
          <p>Nosso conceito é simples: Você paga pequenas parcelas todo mês e adquire diárias para se hospedar em
            qualquer hotel parceiro pelo Clube de Hospedagem. Para fazer parte, escolha a quantidade de diárias, a
            quantidade de pessoas e o plano que mais combina com você. Depois é só escolher seu destino, marcar sua
            viagem e aproveitar! Assista ao nosso vídeo e saiba mais.</p>

          <a (click)="scroll('target_area_indique')" class="btn-red">SAIBA MAIS</a>
        </div>
        <div class="column is-6 text-center">
          <img src="assets/img/economia-nas-diarias.png">
        </div>
      </div>
    </div>
  </section>

  <footer class="text-center">
    <img width="265px" height="65px" src="assets/img/brand/logo-montreal-clube-de-hospedagem-slogan.png"
      alt="Disponível na App Store">
  </footer>

</div>
